import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "../components/ui/accordion";
import { FAQS } from "./data";

export function Faq() {
  return (
    <section id="faq" className="bg-[#111923] text-[#eef4f8] py-24 md:py-32 border-b border-[#213042]" data-testid="faq-section">
      <div className="max-w-4xl mx-auto px-6">
        <div className="mb-12 reveal">
          <span className="font-mono-code text-xs text-[#00c2a8] uppercase tracking-widest block mb-2">// KNOWLEDGE BASE</span>
          <h2 className="font-mono-code text-[clamp(26px,3.4vw,44px)] font-bold uppercase text-white leading-tight">
            Frequently Asked Questions
          </h2>
        </div>

        <Accordion type="single" collapsible className="reveal" data-testid="faq-accordion">
          {FAQS.map((f, i) => (
            <AccordionItem key={i} value={`faq-${i}`} className="border-[#213042]">
              <AccordionTrigger
                className="font-mono-code text-sm uppercase tracking-wide text-white hover:text-[#00c2a8] hover:no-underline py-5 text-left"
                data-testid={`faq-trigger-${i + 1}`}
              >
                {f.q}
              </AccordionTrigger>
              <AccordionContent className="text-sm text-[#a2b8cc] leading-relaxed" data-testid={`faq-content-${i + 1}`}>
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
}
